<template>
  <label class="text-sm font-medium text-gray-700 dark:text-gray-100"><slot /></label>
</template>
